import { DestroyRef, InjectionToken, inject, signal } from '@angular/core';

export const DESTROYED_SIGNAL = new InjectionToken('destroyed_signal', {
  providedIn: 'root',
  factory: () => {
    const sig = signal(false);
    inject(DestroyRef).onDestroy(() => sig.set(true));
    return sig.asReadonly();
  },
});
